const FinancialService = () => {
  return (
    <div>
      <div className="bg-[#efefef] flex justify-center items-center h-[150px]">
        <h1 className="text-[40px] font-bold">Financial Services</h1>
      </div>
      <div className="flex flex-col justify-center  gap-8 max-w-[50rem] mx-auto  p-[3rem]">
        <p>TCS Financial Services aims to be a unique financial services provider in Pakistan
        by creating internal and external strategic alliances. We offer extraordinarily
        customer-oriented products and creative delivery channels to build strong customer
        relationships. Our financial solutions work by employing latest technologies, human
        resource models and forty years of market insights. Our spectrum covers distributing and
        selling financial services to the branchless banking.</p>    
      </div>
    </div>
  );
};

export default FinancialService;
